import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  whiteColor: {
    color: theme.palette.common.white,
  },
  primaryColor: {
    color: COLOR_PURPLE,
  },
  title: {
    color: theme.palette.common.white,
    fontSize: 18,
    textAlign: 'center',
  },
  mainContentBox: {
    backgroundColor: COLOR_PURPLE,
    backgroundImage:
      'url("/images/institutions/background-image-refer-academic-institution-mobile.svg")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  textRefer: {
    color: theme.palette.common.white,
    padding: theme.spacing(2, 0),
    fontSize: 14,
  },
  textInsertEmail: {
    fontSize: 15,
    color: theme.palette.common.white,
    padding: theme.spacing(2, 0),
  },
  input: {
    width: 290,
    fontSize: 16,
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,

    '&:hover': {
      '&::before': {
        borderColor: `${theme.palette.common.white} !important`,
      },
    },

    '&::before, &::after': {
      borderColor: theme.palette.common.white,
    },
  },
  inputText: {
    textAlign: 'center',
  },
  inputFocused: {
    '&::after': {
      borderColor: `${theme.palette.grey[400]} !important`,
    },
  },
  inputLabel: {
    color: theme.palette.common.white,
  },
  inputLabelFocused: {
    color: '#FFF !important',
  },
  feedbackMessage: {
    color: theme.palette.common.white,
    lineHeight: 1.2,
    textAlign: 'center',
  },
}));
